import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Utility function to generate a quote PDF
export const generateQuotePDF = async ({
  quoteData, // Object containing quote data from ManualQuote
  customerData, // Object containing customer information (selected or custom)
}) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const primaryColor = '#384f77';
  const white = '#ffffff';

  // Header
  doc.setFillColor(white);
  doc.rect(0, 0, pageWidth, 20, 'F');
  doc.setFontSize(24);
  doc.setTextColor(primaryColor);
  doc.text('QUOTE', pageWidth / 2, 14, { align: 'center' });

  // Company Information
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(12);
  doc.setTextColor(primaryColor);
  doc.setFont('helvetica', 'bold');
  doc.text('Advanced Controls & Automation', 15, 30);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text('574 Hudson River Road', 15, 36);
  doc.text('Waterford', 15, 42);
  doc.text('NY 12188', 15, 48);

  // Add Company Logo
  const logoImg = new Image();
  logoImg.src = require('../assets/acaLogo.png');
  try {
    await new Promise((resolve, reject) => {
      logoImg.onload = resolve;
      logoImg.onerror = () => reject(new Error('Logo image failed to load'));
      setTimeout(() => reject(new Error('Logo image load timeout')), 5000);
    });
    doc.addImage(logoImg, 'PNG', pageWidth - 45, 25, 30, 30);
  } catch (err) {
    console.error('Error loading logo:', err);
    doc.text('Logo Missing', pageWidth - 45, 40);
  }

  // Quote Information
  doc.setFontSize(10);
  doc.setTextColor(primaryColor);
  doc.text(`Quote #: ${quoteData.quoteNumber}`, 15, 60);
  // Use local time for the date display
 
    doc.text(`Date: ${quoteData.date}`, 15, 66);
doc.text(`Good Until: ${quoteData.goodUntil}`, 15, 72);

  // Customer Information
  doc.setFontSize(12);
  doc.setTextColor(primaryColor);
  doc.setFont('helvetica', 'bold');
  doc.text('Customer:', pageWidth - 15, 60, { align: 'right' });
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'normal');
  let customerY = 66;
  const customerName = customerData.name || 'N/A';
  const customerAddress = customerData.billing_address || customerData.address || '';
  const customerCity = customerData.billing_city || customerData.city || '';
  const customerState = customerData.billing_state || customerData.state || '';
  const customerZip = customerData.billing_zip || customerData.zip || '';
  const customerContact = customerData.billing_contact_name || customerData.billing_contact_email || customerData.contact || '';

  doc.text(customerName, pageWidth - 15, customerY, { align: 'right' });
  if (customerAddress) {
    customerY += 6;
    doc.text(customerAddress, pageWidth - 15, customerY, { align: 'right' });
  }
  if (customerCity && customerState && customerZip) {
    customerY += 6;
    doc.text(`${customerCity}, ${customerState} ${customerZip}`, pageWidth - 15, customerY, { align: 'right' });
  } else {
    const cityStateZip = [customerCity, customerState, customerZip].filter(Boolean).join(', ');
    if (cityStateZip) {
      customerY += 6;
      doc.text(cityStateZip, pageWidth - 15, customerY, { align: 'right' });
    }
  }
  if (customerContact) {
    customerY += 6;
    doc.text(`Contact: ${customerContact}`, pageWidth - 15, customerY, { align: 'right' });
  }

  // Part Details Table (only Part Number Master, Revision, Description)
  doc.setFontSize(10);
  const partTableData = [[
    quoteData.partNumberMaster || quoteData.partNumber || 'N/A',
    quoteData.revision || 'N/A',
    quoteData.description || 'N/A',
  ]];

  autoTable(doc, {
    startY: 90,
    head: [['PART NUMBER', 'REVISION', 'DESCRIPTION']],
    body: partTableData,
    theme: 'grid',
    styles: { fontSize: 10, cellPadding: 2, textColor: [0, 0, 0] },
    headStyles: { fillColor: primaryColor, textColor: [255, 255, 255], fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [240, 240, 240] },
    margin: { left: 15, right: 15 },
    columnStyles: {
      0: { cellWidth: 40 },
      1: { cellWidth: 30 },
      2: { cellWidth: 'auto' },
    },
  });

//   // Total Cost
//   const totalCost = (parseInt(quoteData.quantity) || 0) * (parseFloat(quoteData.priceEach) || 0);
//   doc.setFontSize(12);
//   doc.setTextColor(primaryColor);
//   doc.setFont('helvetica', 'bold');
//   doc.text(`Total Cost: $${totalCost.toFixed(2)}`, pageWidth - 15, doc.lastAutoTable.finalY + 10, { align: 'right' });

  // Pricing Ranges Table
  doc.setFontSize(10);
  doc.setTextColor(primaryColor);
  doc.setFont('helvetica', 'bold');
  doc.text('Pricing Ranges:', 15, doc.lastAutoTable.finalY + 20);
  const pricingTableData = quoteData.pricingRanges.map(range => [
    range.range,
    `$${parseFloat(range.price || 0).toFixed(2)}`,
  ]);

  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 26,
    head: [['QUANTITY RANGE', 'PRICE EACH']],
    body: pricingTableData,
    theme: 'grid',
    styles: { fontSize: 10, cellPadding: 2, textColor: [0, 0, 0] },
    headStyles: { fillColor: primaryColor, textColor: [255, 255, 255], fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [240, 240, 240] },
    margin: { left: 15, right: 15 },
    columnStyles: {
      0: { cellWidth: 50 },
      1: { cellWidth: 50 },
    },
  });

  // Footer - Made in America Image
  const madeInAmericaImg = new Image();
  madeInAmericaImg.src = require('../assets/madeInAmerica.png');
  try {
    await new Promise((resolve, reject) => {
      madeInAmericaImg.onload = resolve;
      madeInAmericaImg.onerror = () => reject(new Error('Made in America image failed to load'));
      setTimeout(() => reject(new Error('Made in America image load timeout')), 5000);
    });
    doc.addImage(madeInAmericaImg, 'PNG', pageWidth - 67.5, pageHeight - 25, 52.5, 15);
  } catch (err) {
    console.error('Error loading Made in America image:', err);
    doc.text('Made in America Missing', pageWidth - 67.5, pageHeight - 25);
  }

  return doc.output('blob');
};